module.exports = __webpack_public_path__ + "static/media/noun_listening_1934261.6bb12097.png";